import { render, staticRenderFns } from "./tabar.vue?vue&type=template&id=77640395&scoped=true"
import script from "./tabar.vue?vue&type=script&lang=js"
export * from "./tabar.vue?vue&type=script&lang=js"
import style0 from "./tabar.vue?vue&type=style&index=0&id=77640395&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77640395",
  null
  
)

export default component.exports